import { useEffect, useState } from 'react'
import { useAuthState as useAuthStateOriginal } from 'react-firebase-hooks/auth'
import { auth } from '../../firebase'

export type AuthState = {
  isSignedIn: boolean // ログイン状態フラグ
  isLoading: boolean // 読み込み中フラグ
  userId?: string
  userName?: string
  email?: string
  error?: Error
}

const INITIAL_AUTH_STATE: AuthState = {
  isSignedIn: false,
  isLoading: true,
  userId: undefined,
  userName: undefined,
  email: undefined,
}

export const useAuthState = (): AuthState => {
  const [authState, setAuthState] = useState(INITIAL_AUTH_STATE)
  const [user, loading, error] = useAuthStateOriginal(auth)

  useEffect(() => {
    if (user) {
      setAuthState({
        isSignedIn: true,
        isLoading: loading,
        userId: user.uid,
        userName: user.displayName || undefined,
        email: user.email || undefined,
        error,
      })
    } else {
      setAuthState({ ...INITIAL_AUTH_STATE, isLoading: loading })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, loading, error])

  return authState
}
